import {
    GET_ADVICE_REQUEST,
    UPDATE_ADVICE_LIST,
    UPDATE_NOW_SELECT_GOODS
} from '../mutationTypes'

import {
    getAdviceList, // 获取保养建议页列表
} from '@/models/advice.js'

// import { calculate } from 'fengche-utils'
import NP from 'number-precision'

const state = {
    drive_mileage: 0, // 汽车公里数
    forecast_drive_mileage: 0, // 预计保养公里数
    model_name: '', // 汽车简称
    maintain_id: '', // 返回一个保养id
    sstore_name: '', // 门店名称
    vehicle_id: 0, // 车型id
    list: [], // 项目列表
    selectData: {
        totalPrices: 0, // 总价
        goodsList: [], // 已选商品数组
        servicesList: [] // 已选服务数组
    },
    nowSelectGoods: {
        selected_num: 0
    } // 当前选择的商品
}

const mutations = {
    [GET_ADVICE_REQUEST] (state, res) {
        state.drive_mileage = res.drive_mileage
        state.forecast_drive_mileage = res.forecast_drive_mileage
        state.model_name = res.model_name
        state.maintain_id = res.maintain_id
        state.sstore_name = res.sstore_name
        state.list = amendArr(res.list)
        state.vehicle_id = res.vehicle_id
        state.selectData = getSelectData(res.list)
    },
    [UPDATE_ADVICE_LIST] (state, res) {
        const list = JSON.parse(JSON.stringify(res))
        state.list = amendArr(list)
        state.selectData = getSelectData(list)
    },
    [UPDATE_NOW_SELECT_GOODS] (state, res) {
        console.log('UPDATE_NOW_SELECT_GOODS', res)
        state.nowSelectGoods = res
    }
}

/**
 * 修正父节点是否选中的状态
 */
const amendArr = (arr) => {
    const newArr = arr.map((item) => {
        const goodsArr = item['goods']
        const goodsFlag = goodsArr.every((childrenItem) => {
            return Number(childrenItem.is_selectd) === 1
        })
        const servicesArr = item['services']
        const servicesFlag = item['services'].every((childrenItem) => {
            return Number(childrenItem.is_selectd) === 1
        })
        if ((goodsFlag || goodsArr.length === 0) && (servicesArr.length === 0 || servicesFlag)) {
            item.is_selectd = 1
        } else {
            item.is_selectd = 0
        }
        return item
    })
    return newArr
}

/**
 * 获取已选数据
 */
const getSelectData = (arr) => {
    /* 选中统计数据 */
    const selectData = {
        totalPrices: 0, // 总价
        goodsList: [], // 已选商品数组
        servicesList: [] // 已选服务数组
    }
    arr.forEach((item) => {
        /* 商品 */
        item.goods.forEach((childrenItem) => {
            /* 限制是否失效 */
            if (childrenItem.is_be_overdue === 0) {
                if (childrenItem.is_selectd) {
                    /* 商品价格 * 商品数量 */
                    let allGoodsPrice = NP.times(childrenItem.discount, childrenItem.selected_num)
                    /* 累加 */
                    selectData.totalPrices = NP.plus(selectData.totalPrices, allGoodsPrice)
                    selectData.goodsList.push(childrenItem)
                }
            }
        })
        /* 服务 */
        item.services.forEach((childrenItem) => {
            /* 限制是否失效 */
            if (childrenItem.is_be_overdue === 0) {
                if (childrenItem.is_selectd) {
                    selectData.totalPrices = NP.plus(selectData.totalPrices, childrenItem.service_price)
                    selectData.servicesList.push(childrenItem)
                }
            }
        })
    })
    return selectData
}

export const actions = {
    async getAdviceData ({ commit }, params) {
        return new Promise((resolve, reject) => {
            try {
                getAdviceList(params)
                    .then((data) => {
                        /* 循环增加 is_selectd 是否选中，isShowAddGoods 是否添加商品 isShowAddService 是否显示选择服务 */
                        const newList = data.list.map((item) => {
                            const goodsArr = item.goods.map((childrenItem) => {
                                childrenItem.sel_num = childrenItem.selected_num  // 添加提示库存不足提示所需字段
                                let selected_num = childrenItem.stock_num <= childrenItem.selected_num ? childrenItem.stock_num : childrenItem.selected_num
                                childrenItem.selected_num = selected_num
                                childrenItem.is_selectd = 1
                                return childrenItem
                            })
                            const servicesArr = item.services.map((childrenItem) => {
                                childrenItem.is_selectd = 1
                                return childrenItem
                            })
                            item.is_selectd = 1
                            item.isShowAddGoods = true
                            item.isShowAddService = true
                            item.goods = goodsArr
                            item.services = servicesArr
                            return item
                        })
                        data.list = newList
                        console.log(newList)
                        commit(GET_ADVICE_REQUEST, data)
                        resolve(data)
                    }).catch(err => {
                        resolve(err)
                    })
            } catch (err) {
                resolve(err)
            }
        })
    },

    /**
     * 更新数据
     */
    updateAdviceList ({ commit }, data) {
        commit(UPDATE_ADVICE_LIST, data)
    },

    /* 更新当前选中的商品id */
    updateNowSelectGoods ({ commit }, data) {
        commit(UPDATE_NOW_SELECT_GOODS, data)
    }
}

export const getters = {}

export default {
    state,
    mutations
}
